// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2iPgR","select":"Header_select__3MvgH","clinic":"Header_clinic__1W99l"};